module.exports = __webpack_public_path__ + "img/connect-by-happiness_3.4c35e7e9.png";